import { useEffect, useRef } from 'react'

let cachedFingerprint: string | null = null

export async function getFingerprint(): Promise<string> {
	if (cachedFingerprint) return cachedFingerprint

	const stored = sessionStorage.getItem('_fp')
	if (stored) {
		cachedFingerprint = stored
		return stored as string
	}

	const FingerprintJS = await import('@fingerprintjs/fingerprintjs')
	const fp = await FingerprintJS.load()
	const result = await fp.get()
	cachedFingerprint = result.visitorId
	sessionStorage.setItem('_fp', cachedFingerprint)
	return cachedFingerprint as string
}

export function useFingerprint() {
	const ready = useRef(false)

	useEffect(() => {
		if (!ready.current) {
			ready.current = true
			getFingerprint().catch(() => {})
		}
	}, [])

	return { getFingerprint }
}
